/// <reference types="@angular/localize" />
import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

async function preload() {
    await google.maps.importLibrary('core')
    await google.maps.importLibrary('maps')
    await google.maps.importLibrary('marker')
}

preload().then(() => {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))
})
